module.exports = __webpack_public_path__ + "img/us.a035edad.svg";